/**
 * Helper per la gestione delle autorizzazioni
 */
import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { appCommonConstants } from '../app.constants';
import { AppAuthService } from '../services/auth.service';
import { AppAuthDataService } from '../services/authData.service';
import { AppLoggerService, AppLoggerType } from '../services/logger.service';

@Injectable({
  providedIn: 'root',
})

/**
 * Servizio per la gestione autorizzazione alla navigazione
 * Ref: https://angular.io/api/router/CanActivate
 */
export class AppAuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private activatedRoute: ActivatedRoute,
    private appAuthService: AppAuthService,
    private authDataService: AppAuthDataService,
    private logger: AppLoggerService,
    private translate: TranslateService
  ) { }

  /**
   * https://angular.io/api/router/CanActivate
   * @param next
   * @param state
   */
  public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.authDataService.urlExistsInMenu(state.url) && window?.location?.hash?.replace("#", "") !== appCommonConstants.defaultRoutes.login) {
      setTimeout(() => this.logger.error({ type: AppLoggerType.DIALOG, title: this.translate.instant("WORD.ATTENZIONE"), message: this.translate.instant("MESSAGE.AUTH.PATH_NOT_ALLOWED", { path: state.url }) }));
      this.appAuthService.gotoLogin();
      return false;
    }

    return true;
  }

  /**
   * https://angular.io/api/router/CanActivateChild
   * @param childRoute
   * @param state
   */
  public canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.authDataService.urlExistsInMenu(state.url) && window?.location?.hash?.replace("#", "") !== appCommonConstants.defaultRoutes.login) {
      setTimeout(() => this.logger.error({ message: this.translate.instant("MESSAGE.AUTH.PATH_NOT_ALLOWED", { path: state.url }) }));
      return false;
    }

    return true;
  }
}
